module.exports = __webpack_public_path__ + "img/zuijia_45.8f01a62c.png";